import { Fragment, h, render } from "preact";
import { useEffect, useState } from "preact/hooks";

const FADE_DURATION = 250;

export default function FadeImage({
  className,
  src,
  alt,
  fetchPriority,
  onLoad = () => {},
}) {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [opacity, setOpacity] = useState(1);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (src === currentSrc) return;

    if (initialLoad) {
      setInitialLoad(false);
      return;
    }

    setOpacity(0);

    // In some cases the transitionend event doesn't fire,
    // so use a timeout instead.
    setTimeout(() => {
      setCurrentSrc(src);
    }, FADE_DURATION);
  }, [src, currentSrc]);

  const handleLoad = () => {
    setInitialLoad(false);
    setOpacity(1);
    onLoad();
  };

  return (
    <img
      className={className}
      alt={alt}
      src={currentSrc}
      onLoad={handleLoad}
      style={{ opacity, "--fade-duration": `${FADE_DURATION}ms` }}
      fetchpriority={fetchPriority}
    />
  );
}
